<div class="loader">
    <core-helpers-box-loading [hidden]="version != null && this.file != null"></core-helpers-box-loading>
</div>
<div *ngIf="version != null && this.file != null" class="version-detail-preview-file">
  <!-- version detail -->
  <core-versions-detail-box
    [version]="version"
  ></core-versions-detail-box>
  <!-- file item -->
  <core-files-list-default-item
    [file]="file"
    [menu]="menu"
    (menuClick)="onMenuClick($event)"
    (iconDownloadClick)="onActionDownloadClick($event)"
  ></core-files-list-default-item>
  <!-- file preview -->
  <core-file-notes
    [file]="file"
    [notesAllowedUser]="notesAllowedUser"
    [context]="context"
    [urlPrefix]="notesUrlPrefix"
    [urlAnnotationsPrefix]="annotationsUrlPrefix"
    [urlSaveAnnotationsPrefix]="annotationsSaveUrlPrefix"
    [canCreateNotes]="canCreateNotes"
  ></core-file-notes>  
</div>
